import { Command } from 'pos/common';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Permission, InvoiceDTO, Res } from 'core/api';
import Tablet from './UpdateInvoiceTipsScreen.Tablet';
import Phone from './UpdateInvoiceTipsScreen.Phone';

import { InvoiceFacade } from 'pos/facades';
import { ThemeManager } from 'pos/ui';
import { Message, Modal } from 'core/ui-next/modal';


declare global {
	interface CommandType {
		updateInvoiceTips: (invoice: InvoiceDTO) => Promise<Result>
	}
}

Command.register('updateInvoiceTips', Preconditions.ensure(Permission.Ticket_UpdateTips), async (invoice: InvoiceDTO): Promise<Result> => {

	const operation = await InvoiceFacade.createTipOperation(invoice.Id);

	if (operation.AvailableMethods.some(x => !x.RegisterTip)) {
		await Message.show(Res.Msg.MSG_THERE_IS_NOT_ANY_PAYMENT_METHOD_THAT_ALLOW_REGISTER_TIP());
		return Result.error();
	}

	const Screen = ThemeManager.selectScreen({ Phone, Tablet });
	const globalId = await InvoiceFacade.getTicketGlobalIdByInvoiceId(invoice.Id);
	return await Modal.show(Screen,
		{
			invoice: { id: invoice.Id, ticketGlobalId: globalId },
			tips: operation.Tips,
			availableMethods: operation.AvailableMethods
		});
});
